<template lang="pug">
v-container(fluid)
  v-row
    //- .col.s12.m6
    //-     .row
    //-         div.col.s12.m6.push-m3
    //-             router-link(v-bind:to="{name: 'index'}")
    //-             img.responsive-img(src="/static/img/inomph_logo_md.png")
    v-col(cols='12').pb-16
      v-row(justify='center')
        v-col(cols='12', sm='12', md='10', lg='9')
          .vertical-space-small
          v-row
            v-col(cols='12', sm='12', md='6')
              app-customer-login
              //- .vertical-space-small
              //- .divider
              //- .vertical-space-small
            v-col(cols='12', sm='12', md='6')
              app-customer-register
              .vertical-space-small
</template>
<script>
import AppCustomerRegister from '@/components/app-customer-register'
import AppCustomerLogin from '@/components/app-customer-login'

export default {
  meta: {
    title: 'Log-in'
  },
  data () {
    return {}
  },
  components: {
    AppCustomerRegister,
    AppCustomerLogin
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-customer-login.vue